import { createSelector } from '@reduxjs/toolkit'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitCategory = createSelector(
  selectFinancialCockpitState,
  ({ selectedCategory }) => selectedCategory
)
